/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  // Find the modal and its overlay
  var mymodal = document.querySelector('#nav-drawer-section');
  //var modalOverlay = document.querySelector('.modal-overlay');

  var modalToggle = document.querySelector('.mobile-menu__button--burger');
  modalToggle.addEventListener('click', openModal);
  
  function openModal() {

    // Listen for and trap the keyboard
    mymodal.addEventListener('keydown', trapTabKey);

    //hide actual overlay content from AT
    document.querySelector('.main-content').setAttribute('aria-hidden', 'true');

    // Listen for indicators to close the modal
    //modalOverlay.addEventListener('click', closeModal);
    
    // LISTEN FOR CLOSE BUTTON CLICK aka when to run closeModal function
    //var signUpBtn = modal.querySelector('#signup');
    //signUpBtn.addEventListener('click', closeModal);
    
    // Find all focusable children
    var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
    var focusableElements = mymodal.querySelectorAll(focusableElementsString);
    
    // Convert NodeList to Array
    focusableElements = Array.prototype.slice.call(focusableElements);
    
    var firstTabStop = focusableElements[0];
    var lastTabStop = focusableElements[focusableElements.length - 1];
    var firstTabHomeLink = document.querySelector('a.drawer__logo');

    lastTabStop.addEventListener('click', closeModal);
    
    lastTabStop.addEventListener('blur', wrapFocus);
    

    
    function trapTabKey(e) {
      
      // Check for TAB key press
      if (e.keyCode === 9) {

        // SHIFT + TAB
        if (e.shiftKey) {
          if (document.activeElement === firstTabStop) {
            e.preventDefault();
            lastTabStop.focus();
          }
  
        // TAB
        } else {
          if (document.activeElement === lastTabStop) {
            e.preventDefault();
            firstTabStop.focus();
          }
        }
      }

      // ESCAPE
      if (e.keyCode === 27) {
        closeModal();
      }
    }
  }

  function wrapFocus() {
    e.preventDefault();
    firstTabHomeLink.focus();
  }

  
  function closeModal() {
    //remove aria-hidden from main
    document.querySelector(".main-content").removeAttribute('aria-hidden');
  }

  let srPasswordText = document.querySelector("#password-text");
  let passwordInput = document.querySelector('input[type="password"]');
  let showPasswordButton = document.querySelector("#show-password");
  let toggleImage = document.querySelector(".show-icon");
  let showPasswordImage = "https://assets.codepen.io/400935/show-password.png";
  let hidePasswordImage = "https://assets.codepen.io/400935/hide-password.png";

  let handleTogglePasswordVisibility = (e) => {
    let buttonState = showPasswordButton.getAttribute("aria-pressed");
    showPasswordButton.setAttribute(
      "aria-pressed",
      buttonState === "false" ? "true" : "false"
    );
    srPasswordText.innerText =
      buttonState === "true" ? "Password hidden" : "Password shown									";
    passwordInput.type = buttonState === "true" ? "password" : "text";
    toggleImage.src =
      buttonState === "true" ? showPasswordImage : hidePasswordImage;
  };
  showPasswordButton.addEventListener("click", handleTogglePasswordVisibility);

  //login validation


  // Set up `blur` and `input` validation for the inputs that can be 
  // validated with the Constraint Validation API.
  document.querySelectorAll('.js-val-input').forEach((inputEl) => {
    //live validation event handlers
    // inputEl.addEventListener('input', (event) =>
    //   updateValidationStateForInput(event.target)
      
    // );
    // inputEl.addEventListener('blur', (event) =>
    //   updateValidationStateForInput(event.target)

    // );
    // Should be set to "false" before any validation occurs.
    inputEl.setAttribute('aria-invalid', 'false');
  });

  const updateValidationStateForInput = (inputEl) => {
    // Check if the input is valid using the Constraint Validation API.
    // Yes, one line of code handles validation. 
    // The Constraint Validation API is cool!
    const isInputValid = inputEl.checkValidity();

    // Handle optional fields that are empty
    if (!inputEl.required && inputEl.value === '' && isInputValid) {
      // Clear validation states.
      inputEl.classList.remove('is-valid', 'is-invalid');
    } else {
      // Required fields: Toggle valid/invalid state classes
      inputEl.classList.toggle('is-validE', isInputValid);
      inputEl.classList.toggle('is-invalidE', !isInputValid);
    }

    //uncomment 

    // Get the error message element for the current input element.
    const errorEl = inputEl.previousElementSibling;
    
    // Use custom validation messages instead of brower built-ins
    errorEl.textContent = getValidationMessageForInput(inputEl)

    // // Show/hide the error message depending on the input's validity.
    //UNCOMMENT
    errorEl.hidden = isInputValid; 

    // Existing code from above here…

    // Update the `aria-invalid` state based on the input's validity.
    // Converts the boolean to a string.
    inputEl.setAttribute('aria-invalid', (!isInputValid).toString());
  };

  // Other setup code…

  const getValidationMessageForInput = (inputEl) => {

  // If the input is valid, return an empty string.
  if (inputEl.validity.valid) return '';

  if (inputEl.name === 'customer[email]') {
    if (inputEl.validity.valueMissing) {
      return 'Error: Please enter your email address.';
    }
    if (inputEl.validity.typeMismatch) {
      return 'Error: Please enter a valid email address. Example: name@domain.com';
    }
  }
  if (inputEl.name === 'customer[password]') {
    if (inputEl.validity.valueMissing) {
      return 'Error: Please enter your password.';
    }
  }
  // Follow the same pattern for the rest of the input fields.
 
  // If all else fails, return the default built-in message.
  return inputEl.validationMessage;

  // The rest of the custom validation message logic goes here.
  }

  const formEl = document.querySelector('.validate-form');
  
  // Turn off built-in form submit validation. 
  formEl.setAttribute('novalidate', '');

 
  //  submit event handler
  const mySubmitFunction = (event) => {

     // Only run on forms flagged for validation
    if (!event.target.classList.contains('validate-form')) return;

    // Update the validation UI state for all inputs.
    document.querySelectorAll('.js-val-input').forEach(updateValidationStateForInput);

    // Get the form element that was submitted.
    const formEl = event.target;
    
    // const isDisFormValid = formEl.checkValidity();
    
    // Set the focus to the first invalid input.
    const firstInvalidInputEl = formEl.querySelector('input:invalid');
    firstInvalidInputEl?.focus();

    // Prevent form submission if any of the validation checks fail.
    if (!formEl.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  
  }; 
  
  
  // Handle form submit validation via JS instead.
  formEl.addEventListener('submit', mySubmitFunction);


 




  // var $validation_error = document.createElement('strong');
  // $validation_error.className = 'form-validation-error';

  // function resetValidation( $field, $parent ) {
  //   $field.removeAttribute('aria-invalid');
  //   $field.removeAttribute('aria-errormessage');
  //   $parent.querySelectorAll('.' + $validation_error.className)
  //     .forEach(function($el){
  //       $parent.removeChild($el);
  //     });
  // }
  
  // function isValid( $field, refocus ) {
    
  //   refocus = refocus || false;

  //   var validity = $field.validity,
  //     $parent = $field.parentNode,
  //     $message = false,
  //     message = '',
  //     message_id = $field.id + '-validation-error';
    
  //   resetValidation( $field, $parent );
  
  //   if ( validity.valid ) {
  //     // valid
  //     return true;
  //   }
    
  //   $message = $validation_error.cloneNode(true);
  //   $message.id = message_id;

  //   if ( $field.validity.valueMissing ) {
  //     message = $field.dataset.errorRequired || 'You forgot to fill in this field';
  //   }
  //   else {
  //     message = $field.dataset.errorInvalid || 'The value you submitted doesn’t look right';
  //   }
  //   $message.innerHTML = message;
    
  //   if ( $field.nextElementSibling ) {
  //     $parent.insertBefore($message, $field.nextElementSibling);
  //   }
  //   else {
  //     $parent.appendChild($message);
  //   }
    
  //   $field.setAttribute('aria-errormessage', message_id);
  //   $field.setAttribute('aria-invalid', 'true');
    
  //   if (refocus) {
  //     $field.focus();
  //   }
    
  //   // not valid
  //   return false;
  // }

  // function validateMe( e ) {
  //   var $form = e.target,
  //       i = 0,
  //       field_count = $form.elements.length,
  //       $first_error = false;
    
  //   for ( i; i< field_count; i++) {
  //     var $field = $form.elements[i],
  //         valid = isValid($field);
  //     if ( !$first_error && !valid ) {
  //       $first_error = $field;
  //     }
  //   }

  //   if ( $first_error ){
  //     e.preventDefault();
  //     $first_error.focus();    
  //   }
  // }

  // var $forms = document.querySelectorAll('form');

  // $forms.forEach(function($form){
  //   $form.setAttribute('novalidate','');
  //   $form.addEventListener('submit', validateMe, false);

  //   var field_count = $form.elements.length;
  //   while (field_count--) {
  //     $form.elements[field_count].addEventListener('change', function(e){
  //       isValid(e.target, true);
  //     }, false)
  //   }
  // });

  



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
